// import "./instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";
import { setupChunkErrorHandling } from "./chunk-error-handler.ts";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import PathSanitizer from "./components/PathSanitizer.tsx";
import ThemeProvider from "./components/theme-provider.tsx";
import { store } from "./redux/store.tsx";
import "./assets/styles/global.css";
// import reportWebVitals from "./reportWebVitals";

// import "./tracing";

setupChunkErrorHandling();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <ThemeProvider defaultTheme='light' storageKey='vite-ui-theme'>
          <BrowserRouter>
            <PathSanitizer />
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// reportWebVitals();
